import axios from "axios";

export const apiUrl = "https://chatapi.dcfever.com";
export const chatMediaUrl = "https://cdn01.dcfever.com/media/chat";
export const imageHost = 'https://cdn01.dcfever.com';
export const webSiteUrl = "https://www.dcfever.com";

export const chatKeywords = [
  '邊度交收方便?',
  '我有興趣呀',
  '有議價空間嗎?',
  '有冇多啲相睇?'
];

export const myFetchPost = async (url, dataObject = {}, headers = {}) => {
  try {
    const response = await axios.post(url, dataObject, {
      headers: headers,
      timeout: 10000,
    });

    const jsonData = await response.data;
    return jsonData;
  } catch (error) {
    /* error other than 200 will be cathed here */
    return Promise.reject(error.message);
  }
};

export const myFetchPost_fetch = async (url, dataObject = {}, headers = {}) => {
  let formData = new FormData();

  for (const [key, value] of Object.entries(dataObject)) {
    formData.append(key, value);
  }

  const requestOptions = {
    method: "POST",
    body: formData,
    headers: headers,
  };
  try {
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      throw new Error("Error Response");
    }
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    return Promise.reject("Error: " + error.message);
  }
};

export const getChatRoomName = (uid1, uid2, itemId) => {
  if (parseInt(uid1) < parseInt(uid2)) {
    return `${parseInt(uid1)}_${parseInt(uid2)}_${itemId}`;
  } else {
    return `${parseInt(uid2)}_${parseInt(uid1)}_${itemId}`;
  }
};

export const getMobileOperatingSystem = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
      return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
  }

  if (/mac/i.test(userAgent)) {
    return "Mac";
  }

  if (/win/i.test(userAgent)) {
    return "Windows";
  }

  return "unknown";
}